<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <h3 class="page-title">{{ title }}</h3>
        </div>
      </div>

      <div class="col-md-12 text-center text-sm-left template-email">
        <d-card class="card">

          <loader v-if="loadingPage" :is-loading="loadingPage"></loader>
          <d-card-body v-else>
            <ValidationObserver tag="form" ref="TemplateValidationForm">
              
              <d-form-row>
                <!-- EmailingGroupType -->
                <d-col md="6" class="form-group">
                  <label>Grupo para o envio</label>
                  <div class="d-flex flex-row fix-width">
                    <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                      <d-select
                        :class="validatedEmailForm | showValidateError(invalid)"
                        :disabled="isSeeing"
                        :value="0"
                        v-model="infoEmail.GroupType.Code"
                      >
                        <option :value="'0'" selected>Nenhum</option>
                        <option
                          v-for="group in groupTypes"
                          v-bind:value="group.Code"
                          v-bind:key="group.Code"
                          v-bind:title="group.Description"
                        >{{group.Name}}</option>
                      </d-select>
                      <div class="invalid-feedback d-block" v-if="validatedEmailForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <d-button
                      v-if="IsCreating"
                      type="button"
                      size="sm"
                      :disabled="GroupTypeInvalidState"
                      v-b-tooltip.hover.bottom
                      title="Visualizar lista de e-mails do grupo selecionado."
                      v-on:click.stop="OpenRecipientsModal($event, false)"
                      class="btn-accent ml-1"
                      style="height: 35.5px;"
                    >
                      <template v-if="!loadingEmailList">
                        <i class="far fa-address-book"></i>
                      </template>
                      <template v-else>
                        <loader :small="true" :labelEnabled="false" :isLoading="true"></loader>
                      </template>
                    </d-button>
                  </div>
                  <small
                    v-if="SelectedGroupDescription"
                    class="form-text text-muted text-left group-description"
                    v-b-tooltip.hover.bottom
                    :title="SelectedGroupDescription"
                  >
                    <i class="fas fa-info-circle mr-1"></i>{{ SelectedGroupDescription }}
                  </small>
                </d-col>
                <!-- Subject -->
                <d-col md="6" class="form-group">
                  <label>Remetente</label>
                    <d-form-input
                      type="text"
                      :disabled="isSeeing"
                      v-model="infoEmail.EmailAddress"
                    />
                </d-col>
              </d-form-row>
              <d-form-row>
                 <d-col md="6" class="form-group">
                  <label>Assunto</label>
                    <d-form-input
                      type="text"
                      :disabled="isSeeing"
                      v-model="infoEmail.Subject"
                    />
                </d-col>
                <d-col md="6" class="form-group">
                  <label>Título</label>
                    <d-form-input
                      type="text"
                      :disabled="isSeeing"
                      v-model="infoEmail.Title"
                    />
                </d-col>
              </d-form-row>
              <ValidationObserver tag="d-form-row" ref="EmailFieldValidation">
                <d-col v-if="IsCreating" md="6" class="form-group">
                  <label>{{Destinatario}}</label>
                  <div class="d-flex flex-row fix-width">
                    <ValidationProvider rules="email" v-slot="{ errors, invalid }">
                      <d-form-input
                        type="email"
                        :class="validatedEmailField | showValidateError(invalid)"
                        v-on:keyup.enter.native="AddEmailToList($event)"
                        :disabled="isSeeing"
                        v-model="infoEmail.Recipient"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedEmailField">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <d-button
                      v-if="IsCreating"
                      size="sm"
                      :disabled="isSeeing"
                      v-b-tooltip.hover.bottom
                      title="Adicionar e-mail à lista de destinatários."
                      v-on:click.stop="AddEmailToList($event)"
                      class="btn-accent ml-1"
                      style="height: 35.5px;"
                    >
                    <i class="fas fa-plus"></i>
                    </d-button>
                  </div>
                </d-col>
                <d-col :md="IsCreating ? '6' : '12' " class="form-group">
                   <label>{{!IsCreating ? 'Destinatários' : ''}}</label>
                   <b-form-textarea
                      :readonly="true"
                      id="custom-formarea"
                      tabindex="-1"
                      type="text"
                      v-bind:value="RecipientList"
                      v-on:click.stop="OpenRecipientsModal($event)"
                    />
                </d-col>
              </ValidationObserver>

              <d-form-row>
                <!-- Content -->
                <d-col md="12" class="form-group">
                  <label>
                    Conteúdo
                    <i
                      class="far fa-question-circle ml-1"
                      style="font-size: 13px;"
                      v-b-tooltip.hover.bottom
                      v-show="!isSeeing"
                      title="Tags HTML também são suportadas! Tente: <br>, <em> e <strong>">
                    </i>
                  </label>
                  <ValidationProvider rules="required|min:10" v-slot="{errors, invalid}">
                    <b-form-textarea
                      :class="validatedEmailForm | showValidateError(invalid)"
                      :disabled="isSeeing"
                      rows="4"
                      type="text"
                      v-model="infoEmail.Content"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedEmailForm"
                    >{{ errors[0] }}</div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>

              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>Visualização</label>
                  <div
                    v-html="templateEmail"
                    class="template-renderer"
                  ></div>
                </d-col>
              </d-form-row>
              <d-form-row v-if="IsCreating">
                <d-col md="12">
                  <label>Anexos</label>
                  <b-form-file
                    type="file"
                    :disabled="isSeeing"
                    multiple="multiple"
                    placeholder="Selecione ou arraste um arquivo"
                    drop-placeholder="Solte o(s) arquivo(s) para adicionar!"
                    browse-text="Selecionar"
                    @change="SelectedFile($event, true)"
                    @input="SelectedFile($event, false)"
                  />
                </d-col>
              </d-form-row>
              <d-form-row v-else-if="infoEmail.Attachments != null">
                <d-col sm="12" md="12" lg="12">
                  <label>Anexos</label>
                  <table class="table mb-0 inline-table">
                    <thead class="bg-s2p-gray-light">
                      <tr>
                        <th>Nome do arquivo</th>
                        <th>Tamanho</th>
                        <th class="text-right"></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(attachment, idxAttach) in infoEmail.Attachments" v-bind:key="'idxAttc' + idxAttach">
                        <td>{{attachment.FileName}}</td>
                        <td>{{GetFileSize(attachment.Size)}}</td>
                        <td class="text-right">
                          <b-button
                            @click="DownloadFile(attachment.Url)"
                          >
                            <i class="fas fa-download"></i>
                          </b-button>
                        </td>
                          
                      </tr>
                      <tr v-if="infoEmail == null || infoEmail.Attachments.length == 0">
                        <td colspan="3">Nenhum anexo</td>
                      </tr>
                    </tbody>
                  </table>
                </d-col>
              </d-form-row>
            </ValidationObserver>
          </d-card-body>
          <!-- Save Changes -->
          <d-card-footer v-if="!loadingPage && (!isSeeing || (isSeeing && loadingAdd))" class="border-top">
            <d-button
              size="sm"
              :disabled="loadingAdd"
              v-on:click.stop="SendEmail()"
              class="btn-accent ml-auto d-table mr-3"
            >
              <template v-if="!isSeeing">
                <i class="fas fa-paper-plane mr-2"></i> Enviar
              </template>
              <template v-else>
                <loader :small="true" :labelEnabled="false" :isLoading="true"></loader>
              </template>
            </d-button>
          </d-card-footer>
        </d-card>
      </div>
    </div>
    
    <b-modal
      id="mEmailingList"
      :title="modalEmailListTitle"
      centered
      :no-close-on-esc="false"
    >
      <div v-if="loadingEmailList">
        <loader :is-loading="loadingEmailList"></loader>
      </div>
      
      <div v-else>
        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Filtrar e-mails</label>
            <div class="d-flex flex-row fix-width">
              <d-form-input
                type="text"
                v-model="filteredEmail"
                v-on:keyup.enter.native="FilterEmails($event)"
                placeholder="email@exemplo.com" />
              <d-button
                size="sm"
                v-b-tooltip.hover.bottom
                title="Limpar filtro."
                v-on:click.stop="ResetFilter($event)"
                class="btn-accent ml-1"
                style="height: 35.5px;"
              >
                <i class="fas fa-eraser"></i>
              </d-button>
            </div>
          </d-col>
        </d-form-row>
       
        <d-form-row>
          <d-col md="12">
            <table class="table mb-0 inline-table" :key="tableKey">
              <thead class="bg-s2p-gray-light">
                <tr>
                  <th>E-mail</th>
                  <th v-if="!tableReadonly" class="text-right"></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(email, idxEmail) in emailListFiltered" v-bind:key="'idxEml' + idxEmail">
                  <td>{{email}}</td>
                  <td v-if="!tableReadonly && IsCreating" class="text-right">
                    <d-button
                        size="sm"
                        v-b-tooltip.hover.bottom
                        title="Remove o e-mail da lista de destinatários."
                        v-on:click.stop="RemoveEmailFromList($event, email)"
                        class="btn-accent"
                      >
                      <i class="fas fa-trash-alt"></i>
                    </d-button>
                  </td>
                </tr>
                <tr v-if="emailListFiltered.length == 0">
                  <td colspan="2">Nenhum e-mail encontrado.</td>
                </tr>
                <tr v-if="hasMoreItems">
                  <td colspan="2" class="text-center"><i>A lista possui mais {{hasMoreItems}} resultados omitidos.</i></td>
                </tr>
              </tbody>
            </table>
          </d-col>
        </d-form-row>

      </div>
      
      <template slot="modal-footer" slot-scope="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "email",
  data: function() {
    return {
      countFilter: 0,
      defaultTemplateEmail: null,
      emailList: [],
      emailListFiltered: [],
      filteredEmail: "",
      groupTypes: [],
      groupTypesEmails: [],
      hasMoreItems: false,
      infoEmail: {
        Attachments: [],
        Content: "",
        GroupType: {
          Code: "0"
        },
        Recipient: "",
        Recipients: [],
        Title: "",
      },
      isSeeing: false,
      loadingAdd: false,
      loadingEmailList: false,
      loadingPage: false,
      modalEmailListTitle: "",
      promises: [],
      tableKey: 0,
      tableReadonly: true,
      templateEmail: null,
      title: "Novo e-mail",
      validatedEmailField: false,
      validatedEmailForm: false,
      year: (new Date).getUTCFullYear().toString(),
    };
  },
  computed: {
    Destinatario() {
      if (this.infoEmail.GroupType.Code == "0")
        return "Destinatário";
      else
        return "Destinatário adicional";
    },
    RecipientList() {
      return this.infoEmail.Recipients.toString();
    },
    GroupTypeInvalidState() {
      return (this.infoEmail.GroupType.Code == '' || this.infoEmail.GroupType.Code == "0" || this.loadingEmailList);
    },
    IsCreating() {
      return this.infoEmail.Id ? false : true;
    },
    SelectedGroupDescription() {
      const code = this.infoEmail.GroupType.Code;
      if (!code || code === "0") return "";

      const group = this.groupTypes.find(g => g.Code === code);
      return group ? group.Description || "" : "";
    }
  },
  watch: {
    "infoEmail.Content": function() {
      this.ReplaceEmailData();
    },
    "infoEmail.Title": function() {
      this.ReplaceEmailData();
    },
    "infoEmail.GroupType.Code": function(nv) {
      this.ListEmailsByGroupType(nv);
    },
  },
  beforeMount() {
    this.loadingPage = true;
    
    this.GetDefaultTemplateEmail();
    this.ListEmailingGroupType();
    
    Promise.all(this.promises).then(() => {
      this.loadingPage = false;
      this.ReplaceEmailData();
    });
  },
  mounted() { 
    let params = this.$route.query;
    if (params != null && params.id) {
      if (params.id != 0) {
        this.isSeeing = true;
        this.title = "Visualizar e-mail"
        this.GetEmail(params.id);
      }
    } else {
      this.title = "Novo e-mail"
    }
  },
  methods: {
    ReplaceEmailData() {
      if (this.defaultTemplateEmail == null)
        return;
      let replacedContentNewLine = this.infoEmail.Content.replace(/\n/g, '<br>');
      let templateChanged = this.defaultTemplateEmail.replace("[#Conteudo#]", replacedContentNewLine);
      templateChanged = templateChanged.replace("[#Titulo#]", this.infoEmail.Title);
      this.templateEmail = templateChanged;
    },
    FilterEmails(ev) {
      ev.preventDefault();

      let filteredEmailList = this.emailList.filter((email) => {
        return email.includes(this.filteredEmail);
      });

      this.SetTableItems(filteredEmailList);
    },
    ResetFilter(ev) {
      this.filteredEmail = "";
      this.FilterEmails(ev);
    },
    SendEmail() {
      this.validatedEmailForm = true;
      this.validatedEmailField = true;

      // Validations and Confirmation.
      this.$refs.TemplateValidationForm.validate().then( isValid => {
        if (isValid) {
          this.validatedEmailForm = false;
          this.validatedEmailField = false;

          if (this.infoEmail.Recipient.length > 0) {
            this.$makeToast(
              "O campo 'Destinatário' possui um email que não foi adicionado à lista de destinatários. Adicione-o à lista ou limpe o campo.",
              "warning",
              "Destinatário não adicionado"
            );
            return
          } else if (this.infoEmail.Recipients.length > 0 || this.infoEmail.GroupType.Code !== "0") {
            this.$makeMsgBox(
              "Atenção, o e-mail será enviado para todos os destinatários inseridos manualmente e também para os do grupo selecionado. Deseja continuar?",
              "Confirmar envio em massa",
              this.AddEmail
            );
          } else {
            this.$makeToast(
              "É necessário selecionar um grupo de envio ou adicionar um destinatário a lista de destinatários.",
              "warning",
              "Sem destinatários"
            );
          }
         
        }
      });
    },
    AddEmailToList(ev) {
      ev.preventDefault();

      this.$refs.EmailFieldValidation.validate().then( isValid => {
        if (isValid) {
          const newEmail = this.infoEmail.Recipient;
          if (newEmail === "") return;

          const alreadyAdded = this.infoEmail.Recipients.find(
            (email) => { return email === newEmail}
          );

          if (!alreadyAdded) {
            this.infoEmail.Recipients.push(newEmail);
            this.infoEmail.Recipient = "";
            this.validatedEmailField = false;
          } else {
            this.$makeToast(
              `Não é possivel adicionar. O e-mail '${newEmail}' já está na lista de destinatários.`,
              "warning",
              "O e-mail já foi adicionado!"
            );
          }

        } else {
          this.validatedEmailField = true;
        }
      });
      
    },
    RemoveEmailFromList(ev, email) {
      ev.preventDefault();
      this.emailListFiltered = this.emailListFiltered.filter(
        (e) => { return e != email }
      );
      this.emailList = this.emailList.filter(
        (e) => { return e != email }
      );
      this.infoEmail.Recipients = this.infoEmail.Recipients.filter(
        (e) => { return e != email }
      );
      this.tableKey += 1;
    },
    OpenRecipientsModal(ev, recipientList=true) {
      ev.preventDefault();

      this.filteredEmail = "";
      
      if (recipientList && this.infoEmail.Recipients.length > 0) {
        this.tableReadonly = false;
        this.emailList = this.infoEmail.Recipients;
        this.SetTableItems(this.emailList);

        this.modalEmailListTitle = "Lista de destinatários";
        this.$bvModal.show("mEmailingList");
      }

      if (!recipientList && this.groupTypesEmails.length > 0) {
        this.tableReadonly = true;
        this.emailList = this.groupTypesEmails;
        this.SetTableItems(this.emailList);
        
        const group = this.groupTypes.filter(
          (g) => { return g.Code === this.infoEmail.GroupType.Code }
        ).pop();
        
        this.modalEmailListTitle = `E-mails do grupo "${group.Name}"`;
        this.$bvModal.show("mEmailingList");
      }
    },
    SelectedFile(obj, isEvent) {
      let files = [];
      if (isEvent) files = obj.target.files;
      else files = obj;
      if (files.length === 0 || typeof(files.forEach) != 'function') return;

      let MAX_MAIL_SIZE = 10240; // 10MiB
      let totalSize = 0;
      files.forEach(file => {
        totalSize += Math.round(file.size / 1024)
      })
      
      if (totalSize > MAX_MAIL_SIZE) {
        this.$makeToast(
          "Tamanho total do email excedeu 10MiB. Verifique o tamanho total do(s) anexo(s).",
          "danger",
          "Limite total excedido"
        );
        return;
      }
      this.infoEmail.Attachments = files;
    },
    SetTableItems(emails) {
      const tableMaxItems = 20;
    
      if (emails.length > tableMaxItems) {
          this.hasMoreItems = emails.length - tableMaxItems;
          this.emailListFiltered = emails.slice(0, tableMaxItems);
      } else {
          this.hasMoreItems = false;
          this.emailListFiltered = emails;
      }
    },
    AddEmail: function() {
      this.loadingAdd = true;
      this.isSeeing = true;
      
      let _content = this.infoEmail.Content.replace(/\n/g, '<br>');

      let email_json  = JSON.parse(JSON.stringify(this.infoEmail));
      email_json.Content = _content;
      delete email_json.Attachments;

      let formData = this.GetFormData(email_json);

      if (this.infoEmail.Attachments && this.infoEmail.Attachments.length > 0) {
        this.infoEmail.Attachments.forEach( file => {
          formData.append("FilesAttached", file, file.name);
        });
      }
      // Add
      this.$store
        .dispatch("AddEmailing", formData)
        .then(() => {
          this.$makeToast(
            "Sucesso ao enviar os e-mails.",
            "success",
            "Emailing"
          );
          setTimeout(() => {
            this.$router.push({
              name: "emailing"
            });
          }, 2200);
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Falha ao enviar os e-mails",
            error
          );
          this.isSeeing = false;
        })
        .finally(() => {
          this.loadingAdd = false;
        });
        
    },
    GetEmail: function(idEmailing) {
      if (idEmailing) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetEmailing", { params: { id: idEmailing }})
          .then(response => {
            if (response) {
              this.infoEmail = response;

              if (response.GroupType.Code == "")
                this.infoEmail.GroupType.Code = "0";
              
              this.infoEmail.Content = this.infoEmail.Content.replace(/<br>/g, '\n');
              
              this.ReplaceEmailData();
            } else {
              this.$makeToast(
              "Não existe E-mail com o ID informado.",
              "danger",
              "Erro ao carregar e-email",
              null
            );
            }
            
          })
          .catch(error => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o e-mail",
              "danger",
              "Erro ao carregar e-email",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetDefaultTemplateEmail: function() {
      const GENERIC_TEMPLATE_ID = 71; // Code: 206

      let promise = new Promise(resolve => {
        this.$store
        .dispatch("GetTemplateEmail", { id: GENERIC_TEMPLATE_ID })
        .then(response => {
          let yearedTemplate = (response.HTML).replace('[#Ano#]', this.year);
          
          this.templateEmail = yearedTemplate;
          this.defaultTemplateEmail = yearedTemplate;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao buscar o template padrão",
            error
          );
        })
        .finally(() => {
          resolve();
        });
      });
      this.promises.push(promise);
    },
    ListEmailingGroupType: function() {
      let promise = new Promise(resolve => {
        this.$store
        .dispatch("ListEmailingGroupType", {})
        .then(response => {
          this.groupTypes = response;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os grupos de e-mail. Tente novamente.",
            "danger",
            "Erro ao listar os grupos de e-mail",
            error
          );
        })
        .finally(() => { resolve(); });
      });
      this.promises.push(promise);
    },
    ListEmailsByGroupType: function(groupType) {
      if (groupType && groupType !== "0") {
        this.loadingEmailList = true;
        this.$store
        .dispatch("ListEmailsByGroupType", { params: { code: groupType }} )
        .then(response => {
          this.groupTypesEmails = response;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os e-mails do grupo selecionado. Tente novamente.",
            "danger",
            "Erro ao listar e-mails do grupo",
            error
          );
        })
        .finally(() => {this.loadingEmailList = false; });
      }
    },
    DownloadFile(url) {
      if (url != null && url.length > 5) window.open(url, "_self");
      else {
        this.$makeToast(
          "O link do arquivo é inválido.",
          "danger",
          "Erro no download",
        );
      }
    },
    GetFileSize(size) {
      if (size != null && size.length > 0) {
        const KiB = size / 1024;
        const MiB = KiB / 1024;
        if (KiB < 1024) return Math.round(KiB) + 'KiB';
        else return Math.round(MiB) + 'MiB';
      }
    },
    GetFormData(object) {
      return this.AppendFormdata(object);
    },
    AppendFormdata(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormdata(obj[property], fd, formKey);
          } else {
            fd.append(formKey, obj[property]);
          }
        }
      }

      return fd;
    },
  }
};
</script>

<style scoped>
.template-email {
  padding-left: 0px;
}
.fix-width > span {
  width: 100%;
}
.group-description {
  display: block;
  margin-top: 4px;
  line-height: 1.3;
}
#custom-formarea {
  height: 35.5px;
  margin-top: 8px;
  cursor: pointer;
}

</style>

<style>
strong {
  font-weight: bold !important;
}

.custom-file-input:focus ~ .custom-file-label::after {
  color: black;
  background: #e5e7ec;
  border-left: none;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/email.vue